export const rapPalette = {
  magenta: {
    0: '#FFFFFF',
    0.5: '#FFE6FE',
    1: '#FFC6FC',
    1.5: '#FFB3FB',
    2: '#FF99FA',
    3: '#FF66F7',
    4: '#FF33F5',
    5: '#FF00F2',
    6: '#CC00C2',
    7: '#990091',
    8: '#660061',
    8.5: '#4D0049',
    9: '#330030',
    9.5: '#1A0018',
    10: '#000000',
  },
  purple: {
    0: '#FFFFFF',
    0.5: '#F3EAFF',
    1: '#E6D4FF',
    1.5: '#DABFFF',
    2: '#CDAAFF',
    3: '#B47FFF',
    4: '#9B55FF',
    5: '#822AFF',
    6: '#6822CC',
    7: '#4E1999',
    8: '#341167',
    8.5: '#270D4D',
    9: '#1A0834',
    9.5: '#0D041A',
    10: '#000001',
  },
};

const interFont = ['Inter', 'sans-serif'].join(',');

export const themeSettings = () => ({
  palette: {
    mode: 'dark',
    primary: {
      main: '#822AFF',
      light: '#B47FFF',
      dark: '#4E1999',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#FF00F2',
      light: '#FF66F7',
      dark: '#990091',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#1A0834',
      paper: '#270D4D',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#E6D4FF',
    },
    rap: rapPalette,
  },
  typography: {
    fontFamily: interFont,
    fontSize: 12,
    h1: { fontFamily: interFont, fontSize: 40, fontWeight: 800 },
    h2: { fontFamily: interFont, fontSize: 32, fontWeight: 800 },
    h3: { fontFamily: interFont, fontSize: 24, fontWeight: 800 },
    h4: { fontFamily: interFont, fontSize: 20, fontWeight: 800 },
    h5: { fontFamily: interFont, fontSize: 16, fontWeight: 700 },
    h6: { fontFamily: interFont, fontSize: 14, fontWeight: 700 },
    body1: { fontFamily: interFont, fontSize: 14 },
    body2: { fontFamily: interFont, fontSize: 12 },
    button: { fontFamily: interFont, fontWeight: 700, textTransform: 'uppercase' },
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          '--Paper-shadow': 'none',
          '--Paper-overlay': 'none',
          boxShadow: 'none',
          backgroundImage: 'none',
        },
      },
    },
  },
});
